import pkg from 'package.json';
import { getUserToken } from '@get-mosh/msh-shared';
import base64 from 'base-64';
import { env } from 'src/env.mjs';

export const getHeaders = () => {
    const userAccessToken = getUserToken();
    const headers = new Headers();
    headers.set(
        'X-API-Key',
        base64.encode(
            `${process.env.NEXT_PUBLIC_RESTFUL_USER}:${process.env.NEXT_PUBLIC_RESTFUL_KEY}`,
        ),
    );
    if (userAccessToken) {
        headers.set('Authorization', `Bearer ${userAccessToken}`);
    }
    headers.set('Content-Type', 'application/json');
    headers.set('X-Brand', 'moshy');
    headers.set('X-Version', pkg.version);
    headers.set('X-Source', 'web');
    headers.set('X-Country-Code', env.NEXT_PUBLIC_COUNTRY_CODE);
    return headers;
};
